import FilaEsperaList from './List/List';

export default function FilaEspera() {
    return <FilaEsperaList />;
}
